import { Card, CardBody, Col } from "reactstrap";
import { OrderThisMonthTitle } from "../../../../../Constants/Constants";
import DashboardCommonHeader from "../../../../CommonComponents/DashboardCommonHeader/DashboardCommonHeader";
import ReactApexChart from "react-apexcharts";
import { CustomerTransaction } from "../../../../../Data/General/Dashboard/ECommerce";

const OrderThisMonth = () => {
  return (
    <Col xl="5" md="6">
      <Card>
        <DashboardCommonHeader title={OrderThisMonthTitle} dropdownClass="dropdown-toggle" />
        <CardBody>
          <div id="customer-transaction">
            <ReactApexChart type="bar" options={CustomerTransaction} series={CustomerTransaction.series} height={300} />
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default OrderThisMonth;
